import { RepeatIcon, WarningIcon } from "@chakra-ui/icons";
import {
  WalletImportMethod,
  SyncState,
  FileImportState,
  PopulatedWallet,
} from "@syla/shared/types/models/WalletBase";
import { differenceInDays } from "date-fns";
import React from "react";

export function getDataSourceStatusProps({
  importMethod,
  lastSynced,
  lastUploaded,
  syncState,
  fileImportState,
}: Pick<
  PopulatedWallet,
  | "importMethod"
  | "lastSynced"
  | "lastUploaded"
  | "syncState"
  | "fileImportState"
>) {
  const isRecentlySynced =
    lastSynced && differenceInDays(new Date(), lastSynced) < 1;

  const importMethodName =
    importMethod === WalletImportMethod.API ? "Sync" : "File";

  if (importMethod === WalletImportMethod.API) {
    // not syncing
    if (!syncState) {
      return {
        importMethodName,
        status: undefined,
        color: "green.500",
        lastUpdated: lastSynced,
      };
    }
    switch (syncState) {
      case SyncState.InProgress:
      case SyncState.Init:
        return {
          importMethodName,
          status: "Syncing...",
          color: "orange.500",
          lastUpdated: lastSynced,
          icon:
            isRecentlySynced ? <RepeatIcon color="orange.500" /> : undefined,
        };
      case SyncState.Error:
        return {
          importMethodName,
          status: "Sync failed",
          color: "red.500",
          lastUpdated: lastSynced,
          icon: <WarningIcon color="red.500" />,
        };
    }
  } else {
    if (!fileImportState) {
      return {
        importMethodName,
        status: undefined, // a file import has no status unless there is an error
        color: "blue.500",
        lastUpdated: lastUploaded,
      };
    }
    switch (fileImportState) {
      case FileImportState.InProgress:
      case FileImportState.Init:
        return {
          importMethodName,
          status: "Importing...",
          color: "orange.500",
          lastUpdated: lastUploaded,
        };
      case FileImportState.Error:
        return {
          importMethodName,
          status: "Import failed",
          color: "red.500",
          lastUpdated: lastUploaded,
          icon: <WarningIcon color="red.500" />,
        };
    }
  }
}
